import {isCustomerNotification} from "../customer-notifications";

export default class NotificationMessageBuilder {
    constructor($filter, $window) {
        this._filter = $filter;
        this._window = $window;

        this.notificationMessages = {
            send_limit: {
                title: {
                    stopped: "NOTIFICATION:TYPE:LIMIT"
                },
                description: {
                    stopped: "NOTIFICATION:DESCRIPTION:LIMIT"
                }
            },
            upload: {
                title: {
                    statement: 'NOTIFICATION:TYPE:UPLOADING_STATEMENT',
                    progress: 'NOTIFICATION:TYPE:UPLOADING',
                    failed: 'NOTIFICATION:TYPE:UPLOADING_FAILED',
                    done: 'NOTIFICATION:TYPE:UPLOADING_DONE',
                    stopped: 'NOTIFICATION:TYPE:UPLOADING_STOPPED'
                },
                description: {
                    statement: 'NOTIFICATION:DESCRIPTION:UPLOADING_STATEMENT',
                    progress: 'NOTIFICATION:DESCRIPTION:UPLOADING',
                    failed: 'NOTIFICATION:DESCRIPTION:UPLOADING_FAILED',
                    done: 'NOTIFICATION:DESCRIPTION:UPLOADING_DONE',
                    stopped: 'NOTIFICATION:DESCRIPTION:UPLOADING_STOPPED'
                }
            },
            sending: {
                title: {
                    statement: 'NOTIFICATION:TYPE:SENDING_STATEMENT',
                    progress: 'NOTIFICATION:TYPE:SENDING',
                    failed: 'NOTIFICATION:TYPE:SENDING_FAILED',
                    done: 'NOTIFICATION:TYPE:SENDING_DONE',
                },
                description: {
                    statement: 'NOTIFICATION:DESCRIPTION:SENDING_STATEMENT',
                    progress: 'NOTIFICATION:DESCRIPTION:SENDING',
                    failed: 'NOTIFICATION:DESCRIPTION:SENDING_FAILED',
                    done: 'NOTIFICATION:DESCRIPTION:SENDING_DONE',
                }
            },
            abTest: {
                title: {
                    statement: 'NOTIFICATION:TYPE:ABTEST_WINNER_COPY',
                    failed: 'NOTIFICATION:TYPE:ABTEST_WINNER_FAILED',
                    done: 'NOTIFICATION:TYPE:ABTEST_WINNER_SENDING_DONE'
                },
                description: {
                    statement: 'NOTIFICATION:DESCRIPTION:ABTEST_COPY',
                    failed: 'NOTIFICATION:DESCRIPTION:ABTEST_FAILED',
                    done: 'NOTIFICATION:DESCRIPTION:ABTEST_SENDING_DONE'
                }
            },
            file_export: {
                title: {
                    failed: 'NOTIFICATION:TYPE:EXPORT_FAILED_HEADER',
                    done: 'NOTIFICATION:TYPE:EXPORT_FINISHED_HEADER'
                },
                description: {
                    done: 'NOTIFICATION:DESCRIPTION:FILE_EXPORT_FINISHED_BODY',
                    failed: ''
                }
            },
            account_export: {
                title: {
                    failed: 'NOTIFICATION:TYPE:EXPORT_FAILED_HEADER',
                    done: 'NOTIFICATION:TYPE:EXPORT_FINISHED_HEADER'
                },
                description: {
                    done: 'NOTIFICATION:DESCRIPTION:ACCOUNT_EXPORT_FINISHED_BODY'
                }
            },
            segmentation_sync: {
                title: {
                    failed: 'NOTIFICATION:TYPE:SEGMENTATION_SYNC_FAILED_HEADER'
                },
                description: {
                    failed: 'NOTIFICATION:DESCRIPTION:SEGMENTATION_SYNC_FAILED_HEADER'
                }
            },
            promo_codes_exhausted: {
                title: 'NOTIFICATION:TYPE:PROMO_CODES_EXHAUSTED',
                description: 'NOTIFICATION:DESCRIPTION:PROMO_CODES_EXHAUSTED'
            },
            missed_tag_in_segment: {
                title: 'NOTIFICATION:TYPE:MISSED_TAG_IN_SEGMENT',
                description: 'NOTIFICATION:DESCRIPTION:MISSED_TAG_IN_SEGMENT'
            },
            invalid_url: {
                title: 'NOTIFICATION:TYPE:INVALID_URL',
                description: 'NOTIFICATION:DESCRIPTION:INVALID_URL'
            },
            request_rate_limit_achieved: {
                title: 'NOTIFICATION:TYPE:REQUEST_RATE_LIMIT_ACHIEVED',
                description: 'NOTIFICATION:DESCRIPTION:REQUEST_RATE_LIMIT_ACHIEVED'
            },
            import_has_failed: {
                title: 'NOTIFICATION:TYPE:IMPORT_HAS_FAILED',
                description: 'NOTIFICATION:DESCRIPTION:IMPORT_HAS_FAILED'
            }
        };

        this.campaignView = this._window.localStorage.getItem('settings.campaign.view');
    }

    getNotificationLink(notification) {
        return {
            send_limit: {
                statement: '',
                progress: '',
                failed: '',
                done: '',
                stopped: ''
            },
            sending: {
                statement: '/campaign/folder/sending/view/' + this.campaignView + '/page/1',
                progress: '/campaign/folder/sending/view/' + this.campaignView + '/page/1',
                failed: '/campaign/folder/draft/view/' + this.campaignView + '/page/1',
                done: '/campaign'
            },
            upload: {
                statement: '',
                progress: '',
                failed: '',
                done: '/subscriber/import/' + notification.instigator.id + '/report',
                stopped: ''
            },
            segmentation_sync: {
                failed: ''
            }
        }
    };

    getMessageFor(notification, section) {
        if (isCustomerNotification(notification)) {
            if (notification.notification_type_id === 5) {}
            return this._filter('translate')(this.notificationMessages[notification.type.name][section])
        }
        return this._filter('translate')(this.notificationMessages[notification.type.name][section][notification.method.name])
    };

    getLink(notification) {
        // Hack for making linking working with upload notifications
        // This should be looked at when notification flow is refactored

        if (! notification.instigator && notification.instigator_id) {
            notification.instigator = {
                id: notification.instigator_id
            }
        }

        if (notification.instigator) {
            return this.getNotificationLink(notification)[notification.type.name][notification.method.name]
        }

        return false;
    };
}
